var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-map"},[(_vm.isLoading)?_c('HdLoadingSpinner'):_vm._e(),_c('iframe',{staticClass:"card-map__iframe",attrs:{"src":_vm.src,"loading":"lazy","title":"map"},on:{"load":function($event){return _vm.handleIframeLoad()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }